<template>
  <normal-excel-upload
    :board="board"
    title="안전보건예산 엑셀 업로드"
    :downloadLink="downloadLink"
    tableTitle="안전보건예산 정보"
    :useFieldCell="true"
    :readExcelData="readExcelData"
    :setSaveFormData="setSaveFormData"
    tableType="detailOnOff"

    :tableHeader="tableHeader"
    :startReadSheet="startReadSheet"
    :finishReadSheet="finishReadSheet"
  >
    <template v-slot:colgroup>
      <col width="100px" v-for="head in tableHeader">
    </template>
    <template v-slot:edit="{ index, data, raw, funcSave }">
      <span v-if="index === 0">{{ data }}</span>
      <span v-if="index === 1"><field-selector class="mx-1" v-model="data.id" @select="(field) => {onSelectField(field, funcSave)}"/></span>
      <span v-if="index === 2"><ml-input class="mx-1" :value="data" type="number" :min-value="2000" :max-value="9999" @input="(year) => { onInputNumber(year, funcSave) }"/></span>
      <span v-if="index === 3">{{ getTotalData('사업계획', '', raw.detailData) | comma}}</span>
      <span v-if="index === 4">{{ getTotalData('증액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 5">{{ getTotalData('계', '', raw.detailData) | comma}}</span>
      <span v-if="index === 6">{{ getTotalData('집행금액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 7">{{ getTotalData('집행률', '', raw.detailData) | percent}}</span>
    </template>
    <template v-slot:column="{ index, data, raw }">
      <span v-if="index === 0">{{ data }}</span>
      <span v-if="index === 1">{{ data.field_name }}</span>
      <span v-if="index === 2">{{ data }}</span>
      <span v-if="index === 3">{{ getTotalData('사업계획', '', raw.detailData) | comma}}</span>
      <span v-if="index === 4">{{ getTotalData('증액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 5">{{ getTotalData('계', '', raw.detailData) | comma}}</span>
      <span v-if="index === 6">{{ getTotalData('집행금액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 7">{{ getTotalData('집행률', '', raw.detailData) | percent}}</span>
    </template>
    <template v-slot:columnDetail="{ detailData, funcSave }">
      <table class="w-full" style="border: none;">
        <colgroup>
          <col width="40px"/>
          <col width="53px"/>
          <col width="150px" v-for="head in tableHeader">
          <col width="94px"/>
        </colgroup>
        <thead>
          <tr style="position: sticky; top:0px; z-index: 1">
            <th colspan="5">항목</th>
            <th class="text-right">사업계획</th>
            <th class="text-right">증액(필요시)</th>
            <th class="text-right">계</th>
            <th class="text-right">집행 금액</th>
            <th class="text-right">집행률</th>
            <th>수정/삭제</th>
          </tr>
        </thead>
        <tbody v-for="group in groups">
          <tr style="position: sticky; top:50px; z-index: 1">
            <th colspan="5">{{ group }}</th>
            <th class="text-right">{{ getTotalData('사업계획', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('증액', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('계', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('집행금액', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('집행률', group, detailData[group].data) | percent }}</th>
            <th></th>
          </tr>
          <fragment v-for="(row, rowIndex) in detailData[group].data">
            <tr v-if="row.edit">
              <td colspan="5"><ml-input v-model="row.group"/></td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.사업계획" @input="funcSave(detailData)"/></td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.증액" @input="funcSave(detailData)"/></td>
              <td class="text-right">{{ getData('계', row.data) | comma }}</td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.집행금액" @input="funcSave(detailData)"/></td>
              <td class="text-right">{{ getData('집행률', row.data) | percent }}</td>
              <td>
                <row-edit-tool
                  :data="rowIndex"
                  v-model = "row.edit"
                  :use-delete="!row.fixed"
                  @open-edit-mode="detailOpenEditMode(detailData, row, funcSave)"
                  @close-edit-mode="detailCloseEditMode(detailData, row, funcSave)"
                  @cancel="detailEditCancel(detailData, row, funcSave)"
                  @delete="detailDelete(detailData, group, rowIndex, funcSave)"
                />
              </td>
            </tr>
            <tr v-else>
              <td colspan="5">{{ row.group }}</td>
              <td class="text-right">{{ row.data.사업계획 | comma }}</td>
              <td class="text-right">{{ row.data.증액 | comma }}</td>
              <td class="text-right">{{ getData('계', row.data) | comma }}</td>
              <td class="text-right">{{ row.data.집행금액 | comma }}</td>
              <td class="text-right">{{ getData('집행률', row.data) | percent }}</td>
              <td class="p-2">
                <row-edit-tool
                  :data="rowIndex"
                  v-model = "row.edit"
                  :use-delete="!row.fixed"
                  @open-edit-mode="detailOpenEditMode(detailData, row, funcSave)"
                  @close-edit-mode="detailCloseEditMode(detailData, row, funcSave)"
                  @cancel="detailEditCancel(detailData, row, funcSave)"
                  @delete="detailDelete(detailData, group, rowIndex, funcSave)"
                />
              </td>
            </tr>
          </fragment>

        </tbody>
      </table>
    </template>
  </normal-excel-upload>
</template>

<script>
import NormalExcelUpload from "@/views/excel-upload/NormalExcelUpload.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import NumberInput from "@/components/NumberInput.vue";
import config from "/public/config";
import RowEditTool from "@/views/excel-upload/RowEditTool.vue";

export default {
  components: {
    RowEditTool,
    NumberInput,
    DateSelector,
    FieldSelector,
    NormalExcelUpload,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      downloadLink: `${config.BASE_API_URL}/storage/app/media/%EB%8F%99%EA%B5%AD%EC%A0%9C%EA%B0%95_%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EC%98%88%EC%82%B0_%EC%97%91%EC%85%80%EB%93%B1%EB%A1%9D_v2.xlsx`,
      tableHeader: ['No.', '사업장명',	'대상년도', '사업계획', '증액', '계', '집행금액', '집행률'],
      groups: [
        "안전보건 시설투자", "안전관계자인건비", "외주공사안전관리비", "안전보호구 및 안전용품", "건강검진 및 의료비",
        "안전보건컨설팅 및 안전검사", "작업환경측정", "교육훈련비 및 안전포상 등", "소방안전 및 기타", "기타(산업안전보건관리비)"],
      fixedItems: {"외주공사안전관리비": ["투자비(공사)", "수선비(공사)"]},

      form: {
        stdInfo: {
          field_id: 0,
          field_name: "",
        },
        산업안전보건관리비: {},
        total: {},
      },
      header: {
        year: 0,
        date: "",
        full: "",
      },

      nextGroupName: ""
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
  },
  methods: {
    onSelectField(field, funcSave) {
      const data = {
        id: field.id,
        field_name: field.field_name,
      }
      const errorMSG = field.id ? "" : "입력된 데이터가 검색되지 않습니다.";
      funcSave(data, errorMSG)
    },
    onInputNumber(number, funcSave) {
      if (number) {
        const errorMSG = !isNaN(Number(`${number}`)) ? "" : "숫자만 입력 가능합니다.";
        funcSave(number, errorMSG)
      } else {
        funcSave("", "");
      }
    },
    readExcelData (rowNumber, cells, dataTypes, func) {
      if (rowNumber === 1) {
        // 사업장명
        const field = func.findFieldByFieldName(cells[6]);
        if (field) {
          this.form.stdInfo.field_id = field.id
          this.form.stdInfo.field_name = field.field_name
        } else {
          this.form.stdInfo.field_id = 0
          this.form.stdInfo.field_name = cells[6]
        }
      }
      else if (rowNumber === 2) {
        // 대상년도
        this.header.year = cells[6];
      }
      else if (rowNumber >= 8) {
        const error = [];
        const 항목 = cells[1];
        if (항목 === '계') return
        if ([...this.groups].indexOf(항목) >=0) this.nextGroupName = 항목
        else {
          if (this.nextGroupName) {
            const key = this.nextGroupName;
            if (!this.form.산업안전보건관리비[key]) this.form.산업안전보건관리비[key] = {
              data: [],
              fixed: false,
              open: false,
            };

            const 사업계획 = !isNaN(Number(cells[2])) ? Number(cells[2]) : 0
            const 증액 = !isNaN(Number(cells[3])) ? Number(cells[3]) : 0
            const 집행금액 = !isNaN(Number(cells[5])) ? Number(cells[5]) : 0

            const 계 = 사업계획 + 증액;
            const 집행률 = 집행금액 / 계;
            this.form.산업안전보건관리비[key].data.push({
              data: {
                계,
                사업계획: cells[2],
                증액: cells[3],
                집행금액,
                집행률,
              },
              group: 항목,
              fixed: this.fixedItems[key] ? this.fixedItems[key].indexOf(항목) >= 0 : false,
            })
          }
        }
      }
    },
    startReadSheet (sheet, func) {
      this.form.산업안전보건관리비 = {}
    },
    finishReadSheet (sheet, func) {
      const error = [];
      const mainData = []; // No. 사업장명 대상년도 월 계 사업계획 증액 집행금액 집행률
      const detailData = this.form.산업안전보건관리비

      mainData.push(func.rowIndex)
      mainData.push({
        id: this.form.stdInfo.field_id,
        field_name: this.form.stdInfo.field_name,
      })
      mainData.push(this.header.year)
      mainData.push(this.getTotalData('사업계획', "", detailData))
      mainData.push(this.getTotalData('증액', "", detailData))
      mainData.push(this.getTotalData('계', "", detailData))
      mainData.push(this.getTotalData('집행금액', "", detailData))
      mainData.push(this.getTotalData('집행률', "", detailData))

      if (mainData[1].id === 0) {
        error[1] = "입력된 데이터가 검색되지 않습니다."
      }
      if (isNaN(Number(mainData[2])) || mainData[2] === 0) {
        error[2] = "대상년도를 입력해주세요."
      }
      func.save(mainData, detailData, error)
    },

    setSaveFormData(datas, stdInfo) {
      const mainData = datas.mainData;
      const form = {
        stdInfo: {
          ...stdInfo,
          field_id: mainData[1].id,
          field_name: mainData[1].field_name,
        },
        산업안전보건관리비: datas.detailData,
        total: {
          "사업계획": mainData[3],
          "증액": mainData[4],
          "계": mainData[5],
          "집행금액": mainData[6],
          "집행률": mainData[7],
        },
        fileList: [],
      }

      const header = {
        year: mainData[2],
        date: '',
        full: `${mainData[2]}-01-01`
      };

      return {
        header,
        body: form
      }
    },

    getData(key, data) {
      const 사업계획 = !isNaN(Number(data['사업계획'])) ? Number(data['사업계획']) : 0;
      const 증액 = !isNaN(Number(data['증액'])) ? Number(data['증액']) : 0;
      const 집행금액 = !isNaN(Number(data['집행금액'])) ? Number(data['집행금액']) : 0;

      if (key === '계') {
        return 사업계획 + 증액;
      } else if (key === '집행률') {
        return 집행금액 / (사업계획 + 증액);
      } else {
        return data[key];
      }
    },

    getTotalData(key, group, data) {
      const _totalData = (key, group, _data) => {
        if (_data && _data.length > 0) {
          if (key === '집행률') {
            const 집행금액 = _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['집행금액'] || 0);
            }, 0);
            const 계 = data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['계'] || 0);
            }, 0);
            return 집행금액 / 계;
          } else {
            return _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data[key] || 0);
            }, 0);
          }
        }
        return 0;
      }
      if (group) {
        return _totalData(key, group, data);
      } else {

        if (key === '집행률') {
          let 계 = 0;
          let 집행금액 = 0;
          for (const group of this.groups) {
            계 += _totalData('계', group, data[group].data);
            집행금액 += _totalData('집행금액', group, data[group].data);
          }
          return 집행금액 / 계;
        } else {
          return this.groups.reduce((acc, cur) => {
            return Number(acc || 0) + Number(_totalData(key, cur, data[cur].data) || 0);
          }, 0);
        }
      }
      return "0";
    },

    detailOpenEditMode (detailData, row, funcSave) {
      row.edit = true;
      row.oldData = JSON.parse(JSON.stringify(row.data));
      funcSave(detailData);
    },

    detailCloseEditMode (detailData, row, funcSave) {
      delete row.edit;
      delete row.oldData;
      funcSave(detailData);
    },

    detailEditCancel (detailData, row, funcSave) {
      row.data = JSON.parse(JSON.stringify(row.oldData));
      delete row.edit;
      delete row.oldData;
      funcSave(detailData);
    },

    detailDelete (detailData, group, rowIndex, funcSave) {
      if (this.useDelete) {
        detailData[group].data.splice(rowIndex, 1);
        funcSave(detailData);
      }
    }
  },
};
</script>

<style scoped lang="scss">
table {
  border-collapse: separate;
  border-spacing: 0;
  border-size: 0;
  width: 100%;

  th, td {
    border: none;
    border-bottom: 1px solid #cdcdcd;

    &.text-right {
      padding-right: 0.5rem;
    }
  }
}
</style>
